module.exports = __webpack_public_path__ + "img/discover.c7720d60.svg";